export const STABLE_EMPTY_OBJECT_REF: Readonly<Record<string, never>> = Object.freeze({});
